import {
  GET_LIST_THUCHIHOPDONG,
  GET_LIST_THUCHIHOPDONG_SUCCESS,
  GET_LIST_THUCHIHOPDONG_FAILURE,
} from "actions/ThuChiHopDong/actionTypes";

const initialState = {
  getListThuChiHopDongLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListThuChiHopDong = (state, action) => ({
  ...state,
  getListThuChiHopDongLoading: true,
});

const getListThuChiHopDongSuccess = (state, action) => {
  return {
    ...state,
    getListThuChiHopDongLoading: false,
    objList: action.payload,
  };
};

const getListThuChiHopDongFailed = (state, action) => ({
  ...state,
  getListThuChiHopDongLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_THUCHIHOPDONG:
      return getListThuChiHopDong(state, action);
    case GET_LIST_THUCHIHOPDONG_SUCCESS:
      return getListThuChiHopDongSuccess(state, action);
    case GET_LIST_THUCHIHOPDONG_FAILURE:
      return getListThuChiHopDongFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
